import { httpClient } from 'apis';
import { AxiosResponse } from 'axios';

export type LoginCountLimits = { applicant: number; manager: number };

// Limits are configuration that rarely changes, so one request is shared by every row in the
// session. A failed request is not cached, so the next call retries.
let limitsPromise: Promise<LoginCountLimits> | null = null;

export const loginCountApi = {
  getLimits(): Promise<LoginCountLimits> {
    if (!limitsPromise) {
      const promise: Promise<LoginCountLimits> = httpClient
        .get('portal/user/login-count-limits')
        .then((response: AxiosResponse<{ data: LoginCountLimits }>) => response.data.data)
        .catch((error) => {
          if (limitsPromise === promise) limitsPromise = null;
          throw error;
        });
      limitsPromise = promise;
    }
    return limitsPromise;
  },
  async reset(userId: number): Promise<{ id: number; login_count: number }> {
    const response: AxiosResponse<{ data: { id: number; login_count: number } }> =
      await httpClient.put(`portal/user/${userId}/reset-login-count`);
    return response.data.data;
  },
};
